import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Dadartopunecabs() {



  const cardData = {


  keyword: "Dadar to Pune Cabs",

  headingDescription: "Trustline Cab provides reliable Dadar to Pune cab services with safe, comfortable, and affordable transportation for business travel, family trips, corporate meetings, railway station transfers, airport connectivity, and outstation journeys. Whether you need a one-way taxi or round-trip cab, our professional chauffeurs ensure punctual pickups and a smooth travel experience from Dadar to Pune. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury vehicles to suit every travel requirement. With transparent pricing, doorstep pickup, easy online booking, flexible travel schedules, experienced drivers, and 24/7 customer support, Trustline Travels is your trusted choice for Dadar to Pune taxi services.",

  topPlaces: [
    {
      title: "Pune Hinjewadi IT Park",
      description: "Hinjewadi IT Park is Pune's leading technology and corporate hub, housing multinational companies, software firms, startups, and business centers. It is a major destination for professionals and corporate travelers commuting from Mumbai."
    },
    {
      title: "Pimpri Chinchwad",
      description: "Pimpri Chinchwad is a major industrial and commercial region near Pune, known for automobile companies, manufacturing units, engineering businesses, and corporate offices. It is an important destination for industrial visits and business travel."
    },
    {
      title: "Kharadi",
      description: "Kharadi is one of Pune's fastest-growing business locations, featuring EON IT Park, multinational companies, commercial complexes, and premium residential developments. It is highly preferred by IT professionals and corporate travelers."
    },
    {
      title: "Pune Airport",
      description: "Pune Airport is an important aviation hub connecting the city with major destinations across India. It is frequently used by business travelers, tourists, and passengers requiring convenient airport transfer services."
    },
    {
      title: "Magarpatta City",
      description: "Magarpatta City is a modern business and residential township known for IT parks, corporate offices, shopping areas, and lifestyle facilities. It attracts professionals, families, and visitors throughout the year."
    },
    {
      title: "Hadapsar",
      description: "Hadapsar is a developing commercial and residential area of Pune featuring IT companies, business parks, educational institutions, and excellent connectivity. It is a preferred location for professionals and families."
    },
    {
      title: "Shaniwar Wada",
      description: "Shaniwar Wada is Pune's iconic historical monument and former residence of the Peshwa rulers. Known for its grand architecture and cultural importance, it is one of Pune's most visited heritage attractions."
    },
    {
      title: "Sinhagad Fort",
      description: "Sinhagad Fort is a historic hill fort near Pune offering beautiful mountain views, trekking opportunities, and insights into Maharashtra's rich history. It is a popular weekend destination for adventure and nature lovers."
    },
    {
      title: "Lonavala",
      description: "Lonavala is a beautiful hill station located between Mumbai and Pune, famous for waterfalls, viewpoints, lush green valleys, and pleasant weather. It is a favorite getaway destination for families and tourists."
    },
    {
      title: "Khandala",
      description: "Khandala is a scenic hill destination near Lonavala, known for misty mountains, peaceful landscapes, waterfalls, and breathtaking viewpoints. It is a popular attraction for travelers enjoying the Mumbai-Pune route."
    }
  ],






"services": [
  {
    "name": "Dadar to Pune Taxi Charges",
    "description": "Check Dadar to Pune Taxi Charges with transparent pricing, affordable fares, and multiple vehicle options. Travel comfortably with professional chauffeurs, clean AC cars, and reliable taxi service for business trips, family travel, airport transfers, and outstation journeys."
  },
  {
    "name": "Dadar to Pune Taxi Service",
    "description": "Book Dadar to Pune Taxi Service for safe and convenient intercity travel with experienced drivers, premium vehicles, doorstep pickup, flexible booking, and comfortable highway transportation."
  },
  {
    "name": "Cab from Dadar to Pune",
    "description": "Choose Cab from Dadar to Pune for reliable travel with Sedan, Ertiga, Innova Crysta, SUV, and premium cars. Enjoy professional chauffeur service, affordable pricing, and smooth long-distance journeys."
  },
  {
    "name": "Dadar Pune Cab Service",
    "description": "Reserve Dadar Pune Cab Service for comfortable travel with clean AC vehicles, trained drivers, transparent fares, and dependable transportation between Dadar and Pune."
  },
  {
    "name": "Dadar Pune Taxi",
    "description": "Book Dadar Pune Taxi for affordable and comfortable travel with experienced chauffeurs, well-maintained cars, flexible schedules, and reliable customer support."
  },
  {
    "name": "Dadar to Pune Cab Service",
    "description": "Choose Dadar to Pune Cab Service for safe highway travel with premium vehicles, professional drivers, fixed pricing, and convenient pickup facilities."
  },
  {
    "name": "Mumbai to Pune Taxi from Dadar",
    "description": "Book Mumbai to Pune Taxi from Dadar for direct intercity travel with comfortable AC vehicles, experienced drivers, affordable fares, and doorstep pickup."
  },
  {
    "name": "Pune to Dadar Taxi",
    "description": "Reserve Pune to Dadar Taxi for return travel with reliable chauffeurs, clean cars, transparent pricing, and comfortable journey options."
  },
  {
    "name": "Taxi from Dadar to Pune",
    "description": "Travel with Taxi from Dadar to Pune featuring professional drivers, premium vehicles, safe highway travel, and affordable taxi packages."
  },
  {
    "name": "Taxi Fare from Dadar to Pune",
    "description": "Get Taxi Fare from Dadar to Pune with competitive pricing, vehicle choices, transparent billing, and comfortable travel solutions."
  },
  {
    "name": "Dadar to Pune Ertiga Cab",
    "description": "Book Dadar to Pune Ertiga Cab for family and group travel with spacious seating, AC comfort, luggage space, and professional chauffeur service."
  },
  {
    "name": "Dadar to Pune Innova Cab",
    "description": "Choose Dadar to Pune Innova Cab for premium travel with comfortable interiors, spacious seating, experienced drivers, and reliable long-distance transportation."
  },
  {
    "name": "Dadar to Pune Sedan Cab",
    "description": "Travel with Dadar to Pune Sedan Cab for economical and comfortable rides with clean vehicles, professional chauffeurs, and affordable fares."
  },
  {
    "name": "Dadar to Pune Cab",
    "description": "Book Dadar to Pune Cab for one-way, round-trip, airport, and outstation travel with multiple vehicle options and reliable chauffeur-driven service."
  },
  {
    "name": "Dadar to Pune Cab Fare",
    "description": "Check Dadar to Pune Cab Fare with transparent rates, no hidden charges, and comfortable travel options including Sedan, Ertiga, Innova Crysta, and SUV."
  },
  {
    "name": "Dadar to Pune Innova Crysta",
    "description": "Book Dadar to Pune Innova Crysta for luxury travel with premium comfort, spacious seating, luggage capacity, and professional driver assistance."
  },
  {
    "name": "Dadar to Pune Ertiga Cab Fare",
    "description": "Find Dadar to Pune Ertiga Cab Fare with affordable pricing, family-friendly seating, reliable service, and comfortable AC travel."
  },
  {
    "name": "Dadar to Pune Sedan Cab Fare",
    "description": "Check Dadar to Pune Sedan Cab Fare for budget-friendly travel with transparent pricing, clean vehicles, and experienced chauffeurs."
  },
  {
    "name": "Dadar to Pune Station Cab",
    "description": "Book Dadar to Pune Station Cab for convenient railway transfers with punctual pickup, professional drivers, and comfortable vehicles."
  },
  {
    "name": "Mumbai to Pune Taxi Fare",
    "description": "Get Mumbai to Pune Taxi Fare details with affordable rates, flexible booking options, and premium vehicle choices."
  },
  {
    "name": "Dadar Taxi Service for Outstation Cabs",
    "description": "Choose Dadar Taxi Service for Outstation Cabs with reliable long-distance travel, experienced drivers, clean AC vehicles, and flexible routes."
  },
  {
    "name": "Dadar to Pune Daily Cab Service",
    "description": "Book Dadar to Pune Daily Cab Service for regular travel needs with comfortable vehicles, professional drivers, and reliable scheduled transportation."
  },
  {
    "name": "Dadar Cab Service",
    "description": "Choose Dadar Cab Service for local and outstation travel with affordable fares, premium cars, and professional chauffeur support."
  },
  {
    "name": "Dadar to Pune Cab Booking",
    "description": "Complete Dadar to Pune Cab Booking online with quick confirmation, vehicle selection, transparent pricing, and hassle-free travel arrangements."
  },
  {
    "name": "Dadar to Pune Car Rental",
    "description": "Select Dadar to Pune Car Rental with chauffeur-driven Sedan, Ertiga, Innova Crysta, SUV, and premium cars for comfortable journeys."
  },
  {
    "name": "Dadar to Pune One Way Cab",
    "description": "Book Dadar to Pune One Way Cab for direct travel with affordable fares, professional drivers, and comfortable AC vehicles."
  },
  {
    "name": "Cheap Dadar to Pune Cab",
    "description": "Choose Cheap Dadar to Pune Cab with budget-friendly rates, reliable service, clean vehicles, and experienced chauffeurs."
  },
  {
    "name": "Book Dadar to Pune Cab Online",
    "description": "Book Dadar to Pune Cab Online with instant confirmation, easy reservation, multiple vehicle options, and secure booking service."
  },
  {
    "name": "Dadar to Pune Outstation Cab",
    "description": "Travel with Dadar to Pune Outstation Cab featuring safe highway journeys, premium cars, professional drivers, and flexible travel schedules."
  },
  {
    "name": "Dadar to Pune Airport Cab",
    "description": "Reserve Dadar to Pune Airport Cab for airport transfers with timely pickup, luggage assistance, AC vehicles, and reliable chauffeur service."
  },
  {
    "name": "24x7 Dadar to Pune Taxi Service",
    "description": "Get 24x7 Dadar to Pune Taxi Service with round-the-clock booking support, professional chauffeurs, and comfortable transportation."
  },
  {
    "name": "Best Dadar to Pune Cab Service",
    "description": "Choose Best Dadar to Pune Cab Service for affordable fares, premium vehicles, experienced drivers, and reliable intercity travel solutions."
  }
],

"tableData": [
  ["Dadar to Pune Taxi Charges", "Dadar to Pune Taxi Service"],
  ["Cab from Dadar to Pune", "Dadar Pune Cab Service"],
  ["Dadar Pune Taxi", "Dadar to Pune Cab Service"],
  ["Mumbai to Pune Taxi from Dadar", "Pune to Dadar Taxi"],
  ["Taxi from Dadar to Pune", "Taxi Fare from Dadar to Pune"],
  ["Dadar to Pune Ertiga Cab", "Dadar to Pune Innova Cab"],
  ["Dadar to Pune Sedan Cab", "Dadar to Pune Cab"],
  ["Dadar to Pune Cab Fare", "Dadar to Pune Innova Crysta"],
  ["Dadar to Pune Station Cab", "Mumbai to Pune Taxi Fare"],
  ["Dadar Taxi Service for Outstation Cabs", "Dadar to Pune Daily Cab Service"],
  ["Dadar to Pune Cab Booking", "Dadar to Pune Car Rental"],
  ["Dadar to Pune One Way Cab", "Cheap Dadar to Pune Cab"],
  ["Book Dadar to Pune Cab Online", "Dadar to Pune Outstation Cab"],
  ["Dadar to Pune Airport Cab", "24x7 Dadar to Pune Taxi Service"],
  ["Best Dadar to Pune Cab Service", ""]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Dadar to Pune Cab Service",
    WhyChoosedescription: "Trustline Travels offers comfortable Dadar to Pune cab services with professional drivers, well-maintained vehicles, and smooth intercity travel solutions."
  },
  {
    WhyChooseheading: "Convenient Pickup from Dadar",
    WhyChoosedescription: "Get doorstep pickup from Dadar railway station, hotels, offices, residential areas, and nearby locations with direct drop anywhere in Pune."
  },
  {
    WhyChooseheading: "Experienced Mumbai Pune Route Drivers",
    WhyChoosedescription: "Our skilled chauffeurs are familiar with the Mumbai-Pune route and provide safe, timely, and comfortable journeys."
  },
  {
    WhyChooseheading: "Comfortable Vehicles for Every Group",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers based on passenger count and travel comfort."
  },
  {
    WhyChooseheading: "Affordable Fare with Clear Pricing",
    WhyChoosedescription: "Enjoy competitive Dadar to Pune cab fares with transparent quotations and no hidden charges before confirming your ride."
  },
  {
    WhyChooseheading: "One Way & Round Trip Options",
    WhyChoosedescription: "Book flexible one-way cabs, return trips, or customized travel plans according to your schedule and destination needs."
  },
  {
    WhyChooseheading: "Perfect for Business & Personal Travel",
    WhyChoosedescription: "Our Dadar to Pune cabs are suitable for office travel, family trips, airport transfers, medical visits, and personal journeys."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Support",
    WhyChoosedescription: "Get quick booking assistance, instant confirmation, and dedicated customer support whenever you need a cab from Dadar to Pune."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Dadar to Pune cab service?",
    answer: "Yes, Trustline Cab offers reliable Dadar to Pune cab services for one-way trips, round trips, corporate travel, and personal journeys."
  },
  {
    question: "Can I book a one-way cab from Dadar to Pune?",
    answer: "Yes, one-way cab booking is available from Dadar to Pune with convenient pickup and drop facilities."
  },
  {
    question: "Where can I get pickup from Dadar?",
    answer: "Pickup is available from Dadar railway station, hotels, offices, residential areas, and nearby locations."
  },
  {
    question: "Which cars are available for Dadar to Pune travel?",
    answer: "We provide Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for comfortable travel."
  },
  {
    question: "Is Dadar to Pune cab service available 24 hours?",
    answer: "Yes, our cab services operate 24/7 to provide convenient travel options at any time."
  },
  {
    question: "Can I book a return cab from Pune to Dadar?",
    answer: "Yes, round-trip cab services are available for passengers requiring return travel between Pune and Dadar."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless included in the confirmed booking fare."
  },
  {
    question: "Can I schedule my Dadar to Pune cab in advance?",
    answer: "Yes, advance booking is recommended to ensure your preferred vehicle and pickup timing."
  },
  {
    question: "Do you provide Dadar to Pune cabs for corporate travel?",
    answer: "Yes, our cab services are suitable for business meetings, employee travel, and corporate transportation requirements."
  },
  {
    question: "How can I book Dadar to Pune Cabs with Trustline Travels?",
    answer: "Provide your pickup location, Pune destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Deshmukh",
    feedback: "The Dadar to Pune journey was managed professionally with excellent timing and comfortable travel arrangements. The driver was polite, experienced, and ensured a smooth ride throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Shweta Kulkarni",
    feedback: "Trustline Travels provided a dependable travel experience with a clean vehicle, easy coordination, and safe driving. The complete journey from Dadar to Pune was comfortable and convenient.",
    rating: 5
  }
];








  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Dadar to Pune Cabs Service",
  "image": "https://www.trustlinetravels.com/assets/images/dadar-to-pune-cabs.webp",
  "description": "Book Dadar to Pune cab service with Trustline Travels for safe, comfortable, and affordable intercity travel. Get one-way, round-trip, airport, and outstation taxi services from Dadar to Pune with Sedan, Ertiga, SUV, Innova, Innova Crysta, and premium cab options available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7516"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/dadar-to-pune-cabs"
  }
};


  return (
    <div>

<Helmet>
  <title>Dadar to Pune Cabs | One Way Taxi Service | +91 8087080034</title>

  <meta
    name="description"
    content="Book Dadar to Pune cab service with Trustline Travels for reliable and affordable travel. Get one-way, round-trip, airport, and private taxi services with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7."
  />

  <meta
    name="keywords"
    content="dadar to pune taxi charges, dadar to pune taxi service, cab from dadar to pune, dadar pune cab service, dadar pune taxi, dadar to pune cab service, mumbai to pune taxi from dadar, pune to dadar taxi, taxi from dadar to pune, taxi fare from dadar to pune, Dadar to Pune Cab, Dadar to Pune Taxi, Dadar Pune One Way Cab, Dadar Pune Outstation Taxi, Dadar Pune Innova Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/93.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Dadartopunecabs;